import { LeaderboardSubmitter, type LeaderboardEntry } from "@yjsgames/leaderboard";
import { GPGS_LEADERBOARDS } from "../data/gpgsData.js";

/** 챕터 랭킹 리더보드 정의(데이터 SSoT) — key "highest_chapter"의 leaderboardId. */
const CHAPTER_LEADERBOARD = GPGS_LEADERBOARDS.find((l) => l.key === "highest_chapter");

/**
 * 진행한 최고 챕터 랭킹 리더보드 제출기 — `@yjsgames/leaderboard`의 추상 LeaderboardSubmitter를 상속.
 * 플랫폼(GPGS/Game Center)은 주입된 LeaderboardClient가 전담하므로 이 클래스는 "챕터 → 점수" 결정만 한다.
 * leaderboardId는 data(gpgsLeaderboards.tsv)에서 — 코드 하드코딩 없음.
 *
 * 입력 = 클리어/도달 챕터. 백엔드(GPGS/Game Center)가 기존 최고점과 비교해 갱신하므로 매 클리어 제출해도
 * "최고 챕터"가 유지된다(환생으로 currentChapter가 줄어도 리더보드 최고값은 보존).
 */
export class ChapterRankingLeaderboard extends LeaderboardSubmitter<number> {
  protected resolveEntry(chapter: number): LeaderboardEntry | null {
    if (!CHAPTER_LEADERBOARD || chapter <= 0) return null;
    return { leaderboardId: CHAPTER_LEADERBOARD.leaderboardId, score: chapter };
  }
}
